import React from 'react'
import StepTitle from '../StepTitle'
import CreativeDirectionChat from './components/CreativeDirectionChat'
import { useCreativeDirection } from './hooks'
import './CreativeDirection.scss'

const CreativeDirection = ({
  formData,
  setFormData,
  videoId,
  onValidationChange,
  onSkipToShotList,
  onRegenerateShotListFromCreative
}) => {
  const creativeDirection = useCreativeDirection({
    formData,
    setFormData,
    videoId,
    onValidationChange
  })

  return (
    <div className="creative-direction">
      <StepTitle
        iconType="compass"
        title="AI Director"
        description="Complete the creative guideline before Sharelook builds the shot list."
      />

      <div className="creative-direction__body">
        <CreativeDirectionChat
          sessionId={creativeDirection.sessionId}
          messages={creativeDirection.messages}
          metadata={creativeDirection.metadata}
          phaseSteps={creativeDirection.phaseSteps}
          phaseData={creativeDirection.phaseData}
          creativeGuideline={creativeDirection.creativeBible}
          progressPercent={creativeDirection.progressPercent}
          creativeStatement={creativeDirection.creativeStatement}
          acceptedExtensions={creativeDirection.acceptedExtensions}
          isCreatingSession={creativeDirection.isCreatingSession}
          isStreaming={creativeDirection.isStreaming}
          isSynthesizingVision={creativeDirection.isSynthesizingVision}
          isUploadingReference={creativeDirection.isUploadingReference}
          referenceUploadProgress={
            creativeDirection.referenceUploadProgress
          }
          referenceUploadStatus={creativeDirection.referenceUploadStatus}
          referenceUploadMessage={creativeDirection.referenceUploadMessage}
          isLockingVision={creativeDirection.isLockingVision}
          isVisionLocked={creativeDirection.isVisionLocked}
          isFinalized={creativeDirection.isFinalized}
          phaseBusyAction={creativeDirection.phaseBusyAction}
          error={creativeDirection.error}
          onStopAgentTurn={creativeDirection.stopCurrentAgentTurn}
          onSendMessage={creativeDirection.sendMessage}
          onUploadRequestedReference={
            creativeDirection.uploadRequestedReference
          }
          onSynthesizeVision={creativeDirection.synthesizeVision}
          onLockVision={creativeDirection.lockVisionAndContinue}
          onExtractPhase={creativeDirection.extractCurrentPhase}
          onVerifyEntity={creativeDirection.verifyCurrentPhaseEntity}
          onVerifyAllPhase={creativeDirection.verifyCurrentPhaseAll}
          onGeneratePhase={creativeDirection.generateCurrentPhase}
          onGenerateStoryboardPlan={creativeDirection.generateStoryboardPlan}
          onRefreshGenerationStatus={
            creativeDirection.refreshGenerationStatus
          }
          onAdvancePhase={creativeDirection.advanceCurrentPhase}
          onFinalizeCreativeDirection={
            creativeDirection.finalizeCreativeDirection
          }
          onStartPrompt={creativeDirection.startPrompt}
          onRetryCreateSession={creativeDirection.retryCreateSession}
          onSkipToShotList={onSkipToShotList}
          onRegenerateShotListFromCreative={
            onRegenerateShotListFromCreative
          }
        />
      </div>
    </div>
  )
}

export default CreativeDirection
